import { render, staticRenderFns } from "./ClassificationBox.vue?vue&type=template&id=ef51190e&scoped=true"
import script from "./ClassificationBox.vue?vue&type=script&lang=js"
export * from "./ClassificationBox.vue?vue&type=script&lang=js"
import style0 from "./ClassificationBox.vue?vue&type=style&index=0&id=ef51190e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51190e",
  null
  
)

export default component.exports